var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content policy-home-page" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { width: "70%", "margin-left": "12%" } },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Insurance.LiabilityInsurance")))]),
            _c("hr", { staticStyle: { border: "1px solid black" } }),
            _c(
              "el-row",
              { attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { span: 2 }
                  },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.ServiceProviders"))
                      )
                    ])
                  ]
                ),
                _vm._l(_vm.serviceProviders, function(item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "title-col",
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 7 }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.imgAgentIcon(item),
                              width: "80%",
                              height: "8%"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [_c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.ProductValue")))])]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 有助于降低业务经营风险、提高企业品牌、形象和信誉;有助于承接优质客户业务，助推企业发展; "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 1、物流责任保险可以为客户提供经营第三方物流业务过程中的全面保障，是一种契合现代物流业发展潮流的新型保险产品。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 2、物流责任保险的责任范围包括在经营物流业务过程中依法应由被保险人承担赔偿责任的物流货物的损失。它将运输中承运人的责任以及仓储、流通加工过程中保管人及加工人的责任融合在一起。 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 一、领航与国际知名再保公司联合开发的独家产品；"
                        ),
                        _c("br"),
                        _vm._v(" 二、承保对象：国际货代本身及其合法的代理人"),
                        _c("br"),
                        _vm._v(
                          " 三、责任期间：从货代接收货物到收货人收到货物所有掌控货物期间的全程责任 "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [_c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.Charges")))])]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [_c("center", [_vm._v(" 3000USD起 ")])],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [_c("center", [_vm._v(" 0.1%起，最低3000RMB ")])],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 保费和预估今年营业收入以及选择的各项赔偿限额挂钩，一单一议，费率低至千分之1，最低保费是17000人民币，年度保费在3-10万人民币不等 "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [_c("h3", [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))])]
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "page-col",
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 7 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium" },
                        on: {
                          click: function($event) {
                            return _vm.toInquiry("xnhb")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Insurance.Inquire")))]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "page-col",
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 7 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium" },
                        on: {
                          click: function($event) {
                            return _vm.toInquiry("htjj")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Insurance.Inquire")))]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "page-col",
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 7 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium" },
                        on: {
                          click: function($event) {
                            return _vm.toInquiry("lhb")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Insurance.Inquire")))]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.ServiceAdvantages")))
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(" 依据客户实际情况定制保险产品"),
                        _c("br"),
                        _vm._v(
                          " 多家供应商询价，客户可选择最优方案且有经纪人给出专业建议"
                        ),
                        _c("br"),
                        _vm._v(
                          " 全流程服务专业把关，真正实现买的放心，赔的省心 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 1、保险产品：提供行业内量身定制适用于企业的保险方案。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 2、理赔服务：自有全资保险公估子公司协助客户进行保险索赔、残值处理等全方位服务；英国劳合社在中国大陆指定的独家代理人。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 3、费率浮动机制：为每一个客户提供费率浮动机制“降本增效”。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 4、培训服务：不定期组织线上事故预防服务培训。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 5、风险提示：实时推送政策信息、风险预警信息。 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _c("center", [
                          _vm._v(" 费率同类险种市场低，保障范围全 ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("h1", [_vm._v(_vm._s(_vm.$t("Insurance.Scanning")))]),
            _c("hr", { staticStyle: { border: "1px solid black" } }),
            _c(
              "el-row",
              { attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { span: 2 }
                  },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.InsuranceCompany")))
                    ])
                  ]
                ),
                _vm._l(_vm.serviceProviders, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: { "margin-top": "8px" },
                      attrs: { item: item }
                    },
                    [
                      _c(
                        "el-col",
                        { staticClass: "title-col", attrs: { span: 7 } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                "text-align": "center"
                              }
                            },
                            [
                              item !== "lhb"
                                ? _c("img", {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      src: _vm.imgIcon("tpybx"),
                                      width: "42%",
                                      height: "3%"
                                    }
                                  })
                                : _vm._e(),
                              _c("img", {
                                attrs: {
                                  src: _vm.imgIcon("zgpa"),
                                  width: "42%",
                                  height: "3%"
                                }
                              }),
                              _c("br"),
                              item !== "lhb"
                                ? _c("img", {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      src: _vm.imgIcon("zgrb"),
                                      width: "42%",
                                      height: "3%"
                                    }
                                  })
                                : _vm._e(),
                              item !== "lhb"
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.imgCompanyIcon(item),
                                      width: "42%",
                                      height: "3%"
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.InsuranceCoverage")))
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 货物损坏：货物挤压变形、湿损、坠地、温控货物变质、偷窃盗抢、丢失、共同海损等。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 错误与疏忽：具体包括无单放货、货物错运提单遗失、单证错误、目的地错误、合同履行过失等。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 第三者责任：具体包括第三方人伤、货损、环境污染、第三方运输工具损害等。"
                        ),
                        _c("br"),
                        _vm._v(
                          " 罚款、关税及其他费用：境内外无人提货、目的港弃货海关查验、检验检疫、法律抗辩、追偿、罚金等费用。 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 在本保险期间，被保险人在经营物流业务过程中，由于下列原因造成物流货物的损失，依法应由被保险人承担赔偿责任的，保险人根据本保险合同的约定负责赔偿："
                        ),
                        _c("br"),
                        _vm._v(" (一)火灾、爆炸；"),
                        _c("br"),
                        _vm._v(
                          " (二)运输工具发生碰撞、出轨、倾覆、坠落、搁浅、触礁、沉没，或隧道、桥梁、码头坍塌；"
                        ),
                        _c("br"),
                        _vm._v(" (三)碰撞、挤压导致包装破裂或容器损坏；"),
                        _c("br"),
                        _vm._v(" (四)符合安全运输规定而遭受雨淋；"),
                        _c("br"),
                        _vm._v(" (五)装卸人员违反操作规程进行装卸、搬运。"),
                        _c("br"),
                        _vm._v(
                          " 赔偿限额：根据客户年运量规模 累计赔偿限额 1000万-2000万 每次事故赔偿限额100-200万 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 保障货代企业员工操作引发的责任风险，包括装柜、仓储、订舱、报关、目的港提货等，保障范围分为三大块：货运及相关责任、错误与疏忽、无单放货，无人提货/弃货、第三者责任 "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [_c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.Deductible")))])]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [_vm._v(" 按约定 ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [_vm._v(" 每起事故RMB6000起 ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [_vm._v(" 1.5万人民币 ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.MaximumIndemnityNorm")))
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(" 货损及相关责任单次限额RMB1,000,000"),
                        _c("br"),
                        _vm._v(" 全年累计RMB1,000,000；"),
                        _c("br"),
                        _vm._v(" 错误与疏忽单次限额RMB1,000,000，"),
                        _c("br"),
                        _vm._v(" 全年累计RMB1,000,000；"),
                        _c("br"),
                        _vm._v(" 第三者责任单次限额RMB1,000,000，"),
                        _c("br"),
                        _vm._v(" 全年累计RMB1,000,000；"),
                        _c("br"),
                        _vm._v(" 关税、罚款及其它费用单次限额RMB1,000,000，"),
                        _c("br"),
                        _vm._v(" 全年累计RMB1,000,000；"),
                        _c("br"),
                        _vm._v(" （单次限额/全年累计RMB4,000,000） ")
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(" 每次事故赔偿限额RMB2,100,000；"),
                        _c("br"),
                        _vm._v(" 全年累计: RMB7,000,000。"),
                        _c("br"),
                        _vm._v(" 第三者责任单次: RMB700,000;"),
                        _c("br"),
                        _vm._v(" 全年累计: RMB2100,000。 ")
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(" 货运及相关责任：80万/100万/150万/200万"),
                        _c("br"),
                        _vm._v(
                          " 错误与疏忽、无单放货，无人提货/弃货：80万/150万"
                        ),
                        _c("br"),
                        _vm._v(" 第三者责任：20万/35万/50万 ")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.ClaimsService")))
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 指定案件管理人全程协助理赔，细心指导理赔单证的规范填写。大案、要案指定法律顾问提供专案咨询服务，可在线自主查询理赔进度，线上、线下均可预约理赔培训。 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(" 拥有自己的公估公司；协助客户提供理赔材料，"),
                        _c("br"),
                        _vm._v(" 跟进理赔流程，完成理赔赔付；"),
                        _c("br"),
                        _vm._v(" 在全球各地超过100个国家拥有理赔网点。 ")
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [_vm._v(" 由领航保的理赔人员和保险公司对接 ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("Insurance.ServiceProviderIntroduction"))
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " “小牛货保”致力于为贸易、物流、运输、供应链、跨境电商等行业提供有效的风险管理方案，合理预防、处理与解决各项风险带来的巨大损失。利用物联网、互联网、人工智能、物流跟踪技术，同时联合在线理赔团队、律师团队、全球代理勘查网络、残值回收渠道为广大客户提供一站式风险管控的综合管理平台，让物流风控更安全、更高效、更全面。 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 华泰经纪是中国再保险集团下的国有制经纪公司，成立至今已经30年，在保险初期风险识别、保险方案设计、保险理赔上拥有全闭环式服务。下属全资子公司，华泰保险公估有限公司为中国劳合社代理，拥有全球的理赔服务网络，能更好的为客户提供理赔咨询，理赔跟踪和现场查勘等服务。 "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-style" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "page-col", attrs: { span: 7 } },
                      [
                        _vm._v(
                          " 领航国际保险经纪有限公司成立于2005年，是经中国银保监会批准的全国性、综合性的保险经纪公司，领航保多年来深耕传统货运险、货代责任险、跨境电商FBA保险、物流责任险、仓储险、集装箱险领域，并携手骏日科技为货代物流企业提供航运资质代办及数据通道发送服务，涵盖FMC资质办理、AMS/ISF/ACI/AFR及上海港等预配舱单发送。未来领航将继续致力于创新各种保险产品服务，全方位满足客户需求。 "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }